import React, { useEffect, useState } from 'react'
import { LoadBooks } from '../../components/searchBooks/loadBooks';
import { SearchBar } from '../../components/searchBooks/searchBar';
import axios from 'axios';
import { LoadingFull } from '../../components/loading';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';

const Books = () => {
  const [data, setData] = useState()
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('id'))
  const [load, setLoad] = useState(false)

  async function getResults() {
    setLoad(true)
    axios({
      method: 'post',
      url: '/api/getResults',
      data: {
          'query': query
      }
    })
    .then(response => {
      console.log(response.data)
      setData(response.data);
      setLoad(false)
    })
    .catch(error => {
      console.log(error);
      setLoad(false)
    });
  }

  useEffect(() => {
    if (searchParams.get('id') !== null && searchParams.get('id') !== '') {
      getResults()
    } else {
      setLoad(true)
      axios.get('/api/books')
        .then(response => {
          setLoad(false)
          setData(response.data);
        })
        .catch(error => {
          console.log(error);
          setLoad(false)
        });
    }
  }, [searchParams.get('id')])

  return (
    <>
      <Helmet>
        <title>BogBanken.dk | Bøger</title>
        <meta name="description" content="Find et stort udvalg af brugte bøger til lave priser. Køb billigere bøger og spar penge!" />
      </Helmet>
      <div className={"relative innerContainer mx-auto py-[100px] min-h-lvh space-y-10" + (typeof data !== 'undefined' && !load ? "" : " h-lvh")}>
        <SearchBar query={query} setQuery={setQuery} data={data} load={load} />

        {typeof data !== 'undefined' && !load ?
          <LoadBooks data={data}/>
        :
          <LoadingFull />
        }

      </div>
    </>
  )
}


export default Books;